import ActionNames from '../../actions/names';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: false,
  emailReportLoading: false,
  onDemandRecentReportData: [],
  onDemandEmailReportData: []
});

function onDemandRecentReport(state = initialState, action) {
  switch (action.type) {
    case ActionNames.REQUEST_ONDEMAND_RECENT_REPORT:
      return state.merge({ onDemandRecentReportData: [], loading: true });
    case ActionNames.RECEIVE_ONDEMAND_RECENT_REPORT:
      return state.merge({ onDemandRecentReportData: action.data, loading: false });
    case ActionNames.FAILURE_ONDEMAND_RECENT_REPORT:
      return state.merge({ error: action.error, loading: false });
    case ActionNames.REQUEST_ONDEMAND_EMAIL_REPORT:
      return state.merge({onDemandEmailReportData: [], emailReportLoading: true});
    case ActionNames.RECEIVE_ONDEMAND_EMAIL_REPORT:
      return state.merge({onDemandEmailReportData: action.data, emailReportLoading: false})
    case ActionNames.FAILURE_ONDEMAND_EMAIL_REPORT:
      return state.merge({ error: action.error, loading: false });
    default:
      return state;
  }
}

export default onDemandRecentReport;
